// src/stage2/sceneExterior/MountainBackdropFlat.jsx
import React, { useEffect } from 'react';
import { useTexture } from '@react-three/drei';
import { useThree } from '@react-three/fiber';
import * as THREE from 'three';

export function MountainBackdrop({
  x = 0,
  z = -70,
  y = 14,
  width = 80,
  height = 45,
  textureUrl = '/stageAssets/stage2/scene/mountainHorizon.png',
  rotationY = 0,
  renderOrder = 10, // farthest back
}) {
  const texture = useTexture(textureUrl);
  const { gl } = useThree();

  useEffect(() => {
    if (!texture) return;
    const maxAniso = gl.capabilities.getMaxAnisotropy();

    texture.anisotropy = maxAniso;
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.needsUpdate = true;
  }, [texture, gl]);

  return (
    <mesh position={[x, y, z]} rotation={[0, rotationY, 0]} renderOrder={renderOrder}>
      <planeGeometry args={[width, height]} />
      <meshBasicMaterial
        map={texture}
        alphaTest={0.15}     // adjust 0.05–0.25 if needed
        transparent={false}  // IMPORTANT: do NOT blend
        depthTest={true}
        depthWrite={true}
        toneMapped={false}
      />
    </mesh>
  );
}
